module.exports = __webpack_public_path__ + "assets/c5ccac42002eb2bdad2823ad55fccf36.jpg";